import * as P from "fp-ts-routing";

export type DebugRoute = {};

export const debugPageMatch = P.lit("debug");
